import axios from 'axios'
import React, { useState } from 'react'
import { Sidebar } from '../../../components/Sidebar/Sidebar'
import { Baseurl } from '../../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export const AddQuestion = () => {
  const [custom, setCustom] = useState(false)
  const [image, setImage] = useState(false)

  // state to store image of a question
  const [img, setImg] = useState(null)
  toast.configure()

  // state to store input values
  const [values, setValues] = useState({
    selectedSub: '',
    question: '',
    correctans: '',
    option1: '',
    option2: '',
    option3: '',
    option4: '',
    complexity: '',
  })

  const [complexity, setComplexity] = useState()
  const [subjects, setSubjects] = useState()
  const [queFile, setQueFile] = useState(null)

  // input onchange
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
  }
  // set image file
  const handleFile = (file) => {
    setImg(file)
  }

  // get complexity
  const getComplexity = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'question/fetchComplexity')
      .then((res) => {
        setComplexity(res.data.data)
      })
      .catch((error) => {})
  }

  // get list of subjects
  const getSubjects = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'subject/fetchAllSubjects')
      .then((res) => {
        setSubjects(res.data.data)
      })
      .catch((error) => {})
  }

  useEffect(() => {
    getComplexity()
    getSubjects()
  }, [])

  // add question custom entry/image of an ques
  const addQues = async (e) => {
    e.preventDefault()

    await axios
      .post(Baseurl.nodeLocal + 'question/addQuestion', {
        sub_id: values.selectedSub,
        c_id: values.complexity,
        que_text: values.question,
        opt1: values.option1,
        opt2: values.option2,
        opt3: values.option3,
        opt4: values.option4,
        correct_ans: values.correctans,
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        // clear values on success
        setValues({
          selectedSub: '',
          question: '',
          correctans: '',
          option1: '',
          option2: '',
          option3: '',
          option4: '',
          complexity: '',
          image: '',
        })
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
      })
  }
  const uploadQueImage = async (e) => {
    e.preventDefault()
    const formdata = new FormData()

    const data = {
      sub_id: values.selectedSub,
      c_id: values.complexity,
      opt1: values.option1,
      opt2: values.option2,
      opt3: values.option3,
      opt4: values.option4,
      correct_ans: values.correctans,
    }

    formdata.append('data', JSON.stringify(data))
    formdata.append('que_text', img)

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }

    await axios
      .post(Baseurl.nodeLocal + 'question/addQuestionImage', formdata, config)
      .then((res) => {})
      .catch((err) => {})
  }

  // add excel file of questions
  const importQue = async (e) => {
    e.preventDefault()
    const formdata = new FormData()

    formdata.append('questionsData', queFile)
    await axios
      .post(Baseurl.nodeLocal + 'question/importQuestions', formdata)
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
      })
  }

  return (
    <div className="row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="col-md-10 mt-4 p-2 d-flex justify-content-center align-items-center flex-column">
        {/* breadcrumbs */}
        <div className="d-flex justify-contetn-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/examdashboard" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item" aria-current="page">
                <Link to="/viewquestion" className="link text-primary">
                  View Questions
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Add Question
              </li>
            </ol>
          </nav>
        </div>
        {/* card to add questions-options-correct answer manual/image of a que */}
        <div className="card w-75 p-3 mt-5">
          <h4 className="d-flex justify-content-center">Add New Question</h4>
          <h6 className="m-b-20 p-b-5 b-b-default f-w-600 mt-5">
            Import Questions File
          </h6>
          <form onSubmit={importQue}>
            <div className="row p-2">
              <input
                className="form-control col-md"
                type="file"
                onChange={(e) => {
                  setQueFile(e.target.files[0])
                }}
                required
              />
              <div className="col-md d-flex justify-content-end">
                <button className="btn btn-primary" type="submit">
                  Submit
                </button>
              </div>
            </div>
          </form>
          <h6 className="m-b-20 p-b-5 b-b-default f-w-600 mt-5">
            Add Question
          </h6>
          <form>
            <div className="row">
              <div className="col-md">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  <h6> Select Subject</h6>
                </label>
                <select
                  className="w-75 form-select"
                  aria-label="Default select example"
                  name="selectedSub"
                  onChange={handleChange}
                  value={values.selectedSub}
                  required
                >
                  <option value="" selected disabled>
                    Select
                  </option>
                  {subjects?.map((i, index) => {
                    return (
                      <option value={i.sub_id} key={index}>
                        {i.name}
                      </option>
                    )
                  })}
                </select>
              </div>
              <div className="col-md mx-2">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  <h6> Select Complexity</h6>
                </label>
                <select
                  className="w-75 form-select"
                  aria-label="Default select example"
                  name="complexity"
                  onChange={handleChange}
                  value={values.complexity}
                  required
                >
                  <option value="" selected disabled>
                    Select
                  </option>
                  {complexity?.map((i, index) => {
                    return (
                      <option value={i.c_id} key={index}>
                        {i.c_name}
                      </option>
                    )
                  })}
                </select>
              </div>
              <div className="col-md mx-2">
                {' '}
                <label htmlFor="floatingSelectGrid mx-2">
                  <h6> Select method to add a question</h6>
                </label>
                <div className="row mx-1 mt-3">
                  <div className="form-check col-md">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault"
                      onChange={() => {
                        setCustom(true)
                        setImage(false)
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault"
                    >
                      <h6> Custom</h6>
                    </label>
                  </div>
                  <div className="form-check col-md">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      onChange={() => {
                        setImage(true)
                        setCustom(false)
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault2"
                    >
                      <h6>Image</h6>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {/* if custom it will show the component to add ques manually */}
            {/* if image it will show the component to add image of a ques */}
            {/* options and correct answer has to enter manually only */}
            <div className="row mt-5">
              <div>
                {custom ? (
                  <div>
                    <form onSubmit={addQues}>
                      <h6 className="m-b-20 p-b-5 b-b-default f-w-600">
                        Add Question
                      </h6>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Enter Question</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <textarea
                            type="text"
                            className="form-control"
                            name="question"
                            onChange={handleChange}
                            value={values.question}
                            required
                          />
                        </div>
                      </div>

                      <h6 className="m-b-20 p-b-5 b-b-default f-w-600">
                        Add Options
                      </h6>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Option 1</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <input
                            type="text"
                            className="form-control"
                            name="option1"
                            onChange={handleChange}
                            value={values.option1}
                            required
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Option 2</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <input
                            type="text"
                            className="form-control"
                            name="option2"
                            onChange={handleChange}
                            value={values.option2}
                            required
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Option 3</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <input
                            type="text"
                            className="form-control"
                            name="option3"
                            onChange={handleChange}
                            value={values.option3}
                            required
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Option 4</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <input
                            type="text"
                            className="form-control"
                            name="option4"
                            onChange={handleChange}
                            value={values.option4}
                            required
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Correct Answer</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <select
                            class="form-select"
                            aria-label="Default select example"
                            name="correctans"
                            onChange={handleChange}
                            value={values.correctans}
                            required
                          >
                            <option selected disabled value="">
                              Select Correct Option
                            </option>
                            <option value="a">Option 1</option>
                            <option value="b">Option 2</option>
                            <option value="c">Option 3</option>
                            <option value="d">Option 4</option>
                          </select>
                        </div>
                      </div>
                      <div className="d-grid gap-2 d-md-flex justify-content-md-start mt-3">
                        <button
                          className="btn btn-primary me-md-2"
                          type="submit"
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                ) : image ? (
                  <div>
                    <h6 className="m-b-20 p-b-5 b-b-default f-w-600">
                      Add Question
                    </h6>
                    <form onSubmit={uploadQueImage}>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Add image for question</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <input
                            type="file"
                            accept="image/*"
                            className="form-control"
                            name="que_text"
                            onChange={(e) => {
                              handleFile(e.target.files[0])
                            }}
                            required
                          />
                        </div>
                      </div>

                      <h6 className="m-b-20 p-b-5 b-b-default f-w-600">
                        Add Options
                      </h6>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Option 1</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <input
                            type="text"
                            className="form-control"
                            name="option1"
                            onChange={handleChange}
                            value={values.option1}
                            required
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Option 2</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <input
                            type="text"
                            className="form-control"
                            name="option2"
                            onChange={handleChange}
                            value={values.option2}
                            required
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Option 3</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <input
                            type="text"
                            className="form-control"
                            name="option3"
                            onChange={handleChange}
                            value={values.option3}
                            required
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Option 4</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <input
                            type="text"
                            className="form-control"
                            name="option4"
                            onChange={handleChange}
                            value={values.option4}
                            required
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Correct Answer</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <select
                            class="form-select"
                            aria-label="Default select example"
                            name="correctans"
                            onChange={handleChange}
                            value={values.correctans}
                            required
                          >
                            <option selected disabled value="">
                              Select Correct Option
                            </option>
                            <option value="a">Option 1</option>
                            <option value="b">Option 2</option>
                            <option value="c">Option 3</option>
                            <option value="d">Option 4</option>
                          </select>
                        </div>
                      </div>
                      <div className="d-grid gap-2 d-md-flex justify-content-md-start mt-3">
                        <button
                          className="btn btn-primary me-md-2"
                          type="submit"
                          // onClick={uploadQueImage}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
